import * as Sentry from "@sentry/browser";

import { enableSentry } from "@formant/core/common/config";
import { generateSentryUrl } from "@formant/core/common/generateSentryUrl";
import { logger } from "@formant/core/common/logger";

Error.stackTraceLimit = 100;

export function captureError(
    error: any,
    options: { message?: string } = {},
): void {
    const sentryEventId = enableSentry
        ? Sentry.captureException(error)
        : undefined;
    logger.error(
        [
            "Captured error",
            ...(options.message ? [options.message] : []),
            ...(error.message ? [error.message] : []),
        ].join(": "),
        {
            ...(sentryEventId
                ? { sentryUrl: generateSentryUrl(sentryEventId) }
                : {}),
            error,
        },
    );

    // for browser devtools to correctly display stack trace with source maps
    // the error must be logged to console as an error object
    // eslint-disable-next-line no-console
    console.error(error);
}
